var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoPinpointBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40761 5.82182C4.14442 6.49704 4 7.23165 4 8C4 12.5455 8 16.6364 10 18C10.8918 17.392 12.1812 16.2417 13.3364 14.7506L4.40761 5.82182ZM5.47453 4.06031L8.32339 6.90917C8.68023 6.36182 9.29786 6 10 6C11.1046 6 12 6.89543 12 8C12 8.70214 11.6382 9.31977 11.0908 9.67661L14.4792 13.065C15.3672 11.5439 16 9.8079 16 8C16 4.68629 13.3137 2 10 2C8.19407 2 6.57449 2.79786 5.47453 4.06031Z",
    fill: "#364DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4L16 17",
    stroke: "#364DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoPinpointBlue);
export default __webpack_public_path__ + "static/media/ic_no_pinpoint_blue.7e98dccbdd6fb5d329dad5083d8ca88a.svg";
export { ForwardRef as ReactComponent };